import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import toast from 'react-hot-toast';

const S3_BUCKET = import.meta.env.VITE_APP_AWS_BUCKET_NAME;
const REGION = import.meta.env.VITE_APP_AWS_REGION;
const ACCESS_KEY = import.meta.env.VITE_APP_AWS_ACCESS_KEY_ID;
const SECRET_ACCESS_KEY = import.meta.env.VITE_APP_AWS_SECRET_ACCESS_KEY;

const s3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY
  },
  endpoint: `https://${REGION}.digitaloceanspaces.com`,
  forcePathStyle: true
});

const UploadImage = async ({ srcData, folderName }) => {
  if (!S3_BUCKET || !REGION || !ACCESS_KEY || !SECRET_ACCESS_KEY) {
    toast.error('Missing required environment variables.');
    console.error('Missing environment variables.');
    return null;
  }

  if (!srcData) {
    toast.error('No file selected for upload.');
    console.error('No file selected for upload.');
    return null;
  }

  const key = `${folderName}/${srcData.name}`;

  try {
    const parallelUpload = new Upload({
      client: s3Client,
      params: {
        Bucket: S3_BUCKET,
        Key: key,
        Body: srcData,
        ContentType: srcData.type,
        ACL: 'public-read'
      }
    });

    await parallelUpload.done();

    // Construct public URL (adjust based on your endpoint)
    const imageUrl = `https://${S3_BUCKET}.${REGION}.digitaloceanspaces.com/${key}`;

    return imageUrl;
  } catch (err) {
    toast.error('Error uploading image');
    console.error('Upload failed:', err);
    throw err;
  }
};

export default UploadImage;
